import PropTypes from 'prop-types';
import { AMOUNT_INPUT_VALUE_TYPE } from 'components/constants';
import Input from 'uikit/Input/Input';

const AmountInput = ({
  name,
  error,
  value,
  onChange,
  onBlur = () => {},
  label,
  placeholder,
  subText,
  className,
  isDisabled,
  isRequired,
  precision = 2,
  returnValueType = AMOUNT_INPUT_VALUE_TYPE.NUMBER
}) => {
  const filterInputtedValue = (value) => {
    const [integerPart, ...fractionParts] = value.split('.');

    if (integerPart === '') {
      return '';
    }

    let filteredValue = integerPart;

    if (fractionParts.length > 0) {
      filteredValue += '.' + fractionParts.join('').substring(0, precision);
    }

    return filteredValue.replace(/[^0-9.]/gim, '');
  };

  const replaceLastCommaToDot = (value) => {
    if (value.endsWith(',')) {
      return value.substring(0, value.length - 1) + '.';
    }
    return value;
  };

  const handleChange = (e) => {
    let value = e.target.value;

    value = replaceLastCommaToDot(value);
    value = filterInputtedValue(value);

    onChange({
      ...e,
      target: {
        ...e.target,
        name,
        value: returnValueType === AMOUNT_INPUT_VALUE_TYPE.NUMBER ? Number(value) : value
      }
    });
  };

  return (
    <Input
      name={name}
      error={error}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      label={label}
      placeholder={placeholder}
      subText={subText}
      className={className}
      isDisabled={isDisabled}
      isRequired={isRequired}
    />
  );
};

AmountInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  subText: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  precision: PropTypes.number,
  returnValueType: PropTypes.string
};

export default AmountInput;
